import { NavLink, rem } from "@mantine/core";
import { IconLayoutDashboard } from "@tabler/icons-react";

export interface AdminDashboardLinkProps {
	onNavigate: () => void;
}

/** Akses cepat dari sidebar admin kembali ke dashboard utama. */
export function AdminDashboardLink({ onNavigate }: AdminDashboardLinkProps) {
	return (
		<NavLink
			component="a"
			href="/"
			label="Dashboard"
			onClick={(event: React.MouseEvent) => {
				event.preventDefault();
				onNavigate();
			}}
			leftSection={
				<IconLayoutDashboard
					style={{ width: rem(18), height: rem(18) }}
					stroke={1.5}
				/>
			}
			styles={{ root: { borderRadius: rem(8) } }}
		/>
	);
}
